// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyDyv9Qfe95yiY_nXIpr3S-VkG3VlRaGWc0",
    authDomain: "confusion-24.firebaseapp.com",
    databaseURL: "https://confusion-24.firebaseio.com",
    projectId: "confusion-24",
    storageBucket: "confusion-24.appspot.com",
    messagingSenderId: "709366046473",
    appId: "1:709366046473:web:ceac76a0c582125dabbdd8",
    measurementId: "G-TJXKQ2RR2F"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
